import { ComponentType, useEffect } from 'react';
import { useLocation } from 'react-router';

import { INCODE_ANALYTICS } from '../IncodeAnalytics';

export const IncodeSwitch = (
  { incode: Incode, splash: Splash, ...props }:
  { incode: ComponentType<any>; splash: ComponentType<any> },
) => {
  const { pathname, state } = useLocation<{ incode?: boolean }>();
  const DisplayComponent = state?.incode ? Incode : Splash;

  useEffect(() => {
    const path = pathname.split('/').at(-1)?.replaceAll('-', '_') || 'incode_overview';
    const finalPath = state?.incode ? path : `${path}_tutorial`;

    INCODE_ANALYTICS.INCODE_SECTION_LOADED(finalPath);
  }, [pathname, state?.incode]);

  return (
    <DisplayComponent {...props} />
  );
};
